import React, { useEffect, useState } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { Link } from "react-router-dom";
import "./videoLibrary.scss";
import videoCamera from "../../../assets/images/videoCamera.svg";
import greySearch from "../../../assets/images/greySearch.png";
import backBtnSmall from "../../../assets/images/backBtnSmall.png";
import { getFromLocalStorage } from "../../../utils/webStorage";
import userService from "../../../services/user.service";
import moment from "moment";
import { CircularProgress } from "@material-ui/core";
import * as timeago from "timeago.js";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";
import { BsXLg } from "react-icons/bs";
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const VideoLibrary = () => {
  const schoolId = getFromLocalStorage("schoolId");
  const [searchQuery, setSearchQuery] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingVideo, setIsFetchingVideo] = useState(false);
  const [isFetchingNextPlaylist, setIsFetchingNextPlaylist] = useState(false);
  const [error, setError] = useState("");
  const [events, setEvents] = useState([]);
  const [totalEvents, setTotalEvents] = useState(0);
  const [category, setCategory] = useState([
    { id: 1, name: "Practice", checked: true },
  ]);
  const [categoryList, setCategoryList] = useState([
    { id: 1, name: "Practice", checked: true },
    { id: 2, name: "Game", checked: false },
    { id: 3, name: "Scout", checked: false },
  ]);
  const [year, setYear] = useState([
    { startDate: "2022-01-01", endDate: "2022-12-31" },
  ]);
  const [yearList, setYearList] = useState([
    {
      id: 1,
      name: "2022-2023",
      startDate: "2022-01-01",
      endDate: "2022-12-31",
      checked: true,
    },
    {
      id: 2,
      name: "2021-2022",
      startDate: "2021-01-01",
      endDate: "2021-12-31",
      checked: false,
    },
    {
      id: 3,
      name: "2020-2021",
      startDate: "2020-01-01",
      endDate: "2020-12-31",
      checked: false,
    },
  ]);
  const [eventListId, setEventListId] = useState({ eventId: 0, eventInd: 0 });
  const [playListId, setPlayListId] = useState();
  const [playListVideos, setPlayListVideos] = useState([]);
  const [videoPaginationCount, setVideoPaginationCount] = useState(0);
  const [videoPath, setVideoPath] = useState("");
  const [openVideo, setOpenVideo] = useState(false);

  const handleSearch = () => {
    getEvents();
  };
  const handleCategory = (e) => {
    const { value, checked } = e.target;
    let checkedcategory = categoryList.map((el) => {
      if (el.id == value) {
        return { ...el, checked: !el.checked };
      } else {
        return el;
      }
    });
    let tempCate = checkedcategory.filter((el) => el.checked == true && el);
    setCategoryList(checkedcategory);
    setCategory(tempCate);
  };
  const handleYearFilter = (e) => {
    let yearId = e.target.value;
    let checkedYear = yearList.map((el) => {
      if (el.id == yearId) {
        return { ...el, checked: true };
      } else {
        return { ...el, checked: false };
      }
    });
    const filterYear = checkedYear.filter((el) => el.checked == true && el);
    setYearList(checkedYear);
    setYear(filterYear);
  };

  const getEvents = async () => {
    const filterCategory = category.map((el) => el.name);
    setIsFetching(true);
    try {
      const { data } = await userService.getAllEventLibrary(
        filterCategory,
        schoolId,
        searchQuery,
        year
      );
      data.data.events = data.data.events.map((el) => {
        el.eventPagination = 0;
        return el;
      });

      setEvents(data.data.events);
      setTotalEvents(data.data.total);
      setIsFetching(false);
    } catch (error) {
      setIsFetching(false);
      setError(error.message);
    }
  };

  const eventPaginationHandler = (event, index) => {
    setEventListId({ eventId: event.id, eventInd: index });
    handleEventsPagination(
      events[index].eventPagination,
      event.playlists[event.playlists.length - 1].id,
      event.id,
      index
    );
    let fullEventsCopy = [...events];
    let eventObj = fullEventsCopy[index];
    eventObj.eventPagination = eventObj.eventPagination + 1;
    events[index] = eventObj;
    setEvents(events);
  };

  const handleEventsPagination = async (
    eventPaginationInd,
    playlisID,
    eventID,
    index
  ) => {
    setIsFetchingNextPlaylist(true);
    setPlayListId(null);
    const filterCategory = category.map((el) => el.name);
    const body = {
      categoryNameList: filterCategory,
      schoolId: schoolId,
      playlistId: playlisID,
      eventId: eventID,
      searchBy: searchQuery,
      filterDates: year,
    };
    try {
      const { data } = await userService.getPaginationEvents(
        body,
        eventPaginationInd
      );
      setIsFetchingNextPlaylist(false);

      let fullEventsCopy = [...events];
      let playlistArr = fullEventsCopy[index].playlists;
      fullEventsCopy[index].playlists = [
        ...playlistArr,
        ...data.data.playlists,
      ];
      setEvents(fullEventsCopy);
    } catch (e) {
      setIsFetchingNextPlaylist(false);
      setError(true);
    }
  };

  useEffect(() => {
    videoPaginationCount &&
      schoolId &&
      getPlayListVideo(playListId, eventListId);
  }, [videoPaginationCount]);

  const VidePaginationHandler = (button) => {
    if (button == "next") {
      setVideoPaginationCount((prev) => prev + 1);
    } else if (button == "prev") {
      setVideoPaginationCount((prev) => prev - 1);
    }
  };
  const getPlayListVideo = async (playListID, eventId) => {
    setPlayListVideos([]);
    setEventListId(eventId);
    setPlayListId(playListID);
    setIsFetchingVideo(true);
    if (playListID != playListId) {
      setVideoPaginationCount(0);
    }
    try {
      const { data } = await userService.getEventMedia(
        playListID,
        videoPaginationCount
      );
      setIsFetchingVideo(false);
      !data.data.empty && setPlayListVideos(data.data);
    } catch (e) {
      setIsFetchingVideo(false);
      setError(e.message);
    }
  };

  useEffect(() => {
    searchQuery == "" && getEvents();
  }, [year, category, , searchQuery]);

  const displayVideo = (videoPath) => {
    setOpenVideo(true);
    setVideoPath(videoPath);
  };
  const closeVideoPopup = () => {
    setOpenVideo(false);
  };
  return (
    <div>
      <SchoolAdminDashboard />

      <div className="videoLibrary">
        <div className="videoLibrarySidebar">
          <div className="videoLibrarySidebarHeader">
            <Link to="/schooladmindata">
              <img src={backBtnSmall} alt="back" />
            </Link>
            <span className="bold fs-22 mobofont20">Video Library</span>
          </div>
          <div className="videoLibrarySidebarFilterBy">
            <div className="videoLibrarySidebarFilterByItem">
              <div className="videoLibrarySidebarFilterByHeader filter-share">
                <span className="videoLibrarySidebarFilteTitleText bold fs-18 mobofont16">
                  Filter by
                </span>
                <span className="fs-16 fmlabel semi-bold cp">
                  <p className="clear-btn-video-library">Clear</p>
                </span>
              </div>
            </div>
            <div className="videoLibrarySidebarFilterByItem">
              <div>
                <span className="videoLibrarySidebarFilteTitleText bold fs-18 mobofont22">
                  Category
                </span>
                <div className="videoLibrarySidebarFilterByContainer">
                  {categoryList.map((el) => (
                    <div className="videoLibrarySidebarCheckBox" key={el.id}>
                      <input
                        type="checkbox"
                        value={el.id}
                        checked={el?.checked || false}
                        onChange={handleCategory}
                      />
                      <span> {el.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="videoLibrarySidebarFilterByItem">
              <div>
                <span className="videoLibrarySidebarFilteTitleText bold fs-18 mobofont22">
                  Year
                </span>
                <div className="videoLibrarySidebarFilterByContainer">
                  {yearList.map((el) => (
                    <div className="videoLibrarySidebarCheckBox" key={el.id}>
                      <input
                        type="radio"
                        value={el.id}
                        checked={el.checked}
                        onChange={handleYearFilter}
                      />
                      <span>{el.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="videoLibraryContent">
          <div className="videoLibraryContentSearch ">
            <img src={greySearch} />
            <input
              type="search"
              placeholder="Search Event..."
              className="videoLibraryContentSearchInput regular "
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            {searchQuery && (
              <span onClick={handleSearch} className="videoLibSearchBtn">
                Search
              </span>
            )}
          </div>

          <div className="videoLibraryContentContainer">
            <div className="videoContentHeader">
              <div className="videoContentHeaderLinks">
                <Link to="/uploadvideo" className="uploadVideo">
                  <img src={videoCamera} alt="uploadVideo" />
                  <span className="video-library-btns semi-bold vcenter">
                    {" "}
                    Upload Video
                  </span>
                </Link>
                <Link to="/videoplayer" className="uploadVideo">
                  <EditIcon style={{ color: "#002244" }} />
                  <span className="video-library-btns semi-bold vcenter">
                    {" "}
                    Video Edit
                  </span>
                </Link>
              </div>
            </div>
            {isFetching ? (
              <div className="eventLoader">
                {" "}
                <CircularProgress />{" "}
              </div>
            ) : (
              <div className="eventContainer">
                <h5 className="fs-18 added-text dblack eventTitleText">
                  {totalEvents == 0
                    ? "There is no Event Available in this category"
                    : `Total Events (${totalEvents})`}
                </h5>
                <hr />
                <div>
                  {events &&
                    events.map((event, ind) => (
                      <div key={event.id}>
                        <h5 className="fs-18 added-text dblack eventDate ">
                          {timeago.format(event.createdAt)}
                        </h5>
                        <div className="videoLibraryCards">
                          <div
                            className="videoLibraryCard videoLibraryEventCard"
                            style={{ padding: "18px" }}
                          >
                            <div className="textEvent">Event</div>
                            <h6 className="fs-18 semi-bold dblack">
                              {event.eventName}
                            </h6>
                            <h6 className="fs-18 semi-bold dblack">
                              {event.playlistName}
                            </h6>
                            <div className="clear20"></div>
                            <p className="regular fs-16 dgrey-new">
                              {event.eventDescription}
                            </p>
                            <div className="clear10"></div>
                            <div className="fs-14 text98 playListBottom">
                              {moment(event.eventDate).format("MM/DD/YYYY")}
                              <span className="fs-18 semi-bold dblack">
                                [{event.playlistsCount}]
                              </span>
                            </div>
                          </div>
                          <>
                            {event.playlists.map((playlist) =>
                              playlist.eventMediasCount > 0 ? (
                                <div key={playlist.id}>
                                  <span
                                    className={
                                      playlist.id === playListId
                                        ? "videoLibraryCard videoLibraryCardBorder "
                                        : "videoLibraryCard"
                                    }
                                    onClick={() =>
                                      getPlayListVideo(playlist.id, event.id)
                                    }
                                  >
                                    <div className="textPlaylist">Playlist</div>
                                    <h6 className="fs-18 semi-bold dblack   ">
                                      {playlist.playlistName}{" "}
                                    </h6>
                                    {playlist.eventMedias &&
                                      playlist.eventMedias.length > 0 && (
                                        <video
                                          src={
                                            playlist.eventMedias[0].videoPath
                                          }
                                          className="firstplaylistVideoImg"
                                          alt="/"
                                        />
                                      )}
                                    <div className="fs-14 text98  playListBottom">
                                      {moment(playlist.updatedAt).format(
                                        "DD/MM/YYYY"
                                      )}{" "}
                                      <span>[{playlist.eventMediasCount}]</span>
                                    </div>
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  <span
                                    className={
                                      playlist.id === playListId
                                        ? "videoLibraryCard videoLibraryCardBorder "
                                        : "videoLibraryCard"
                                    }
                                  >
                                    <div className="textPlaylist">Playlist</div>
                                    <h6 className="fs-18 semi-bold dblack   ">
                                      {playlist.playlistName}{" "}
                                    </h6>
                                    <p
                                      className="firstplaylistVideoImg black"
                                      style={{
                                        position: "absolute",
                                        top: "45%",
                                      }}
                                    >
                                      No Videos Available
                                    </p>
                                    <div className="fs-14 text98  playListBottom">
                                      {moment(playlist.updatedAt).format(
                                        "DD/MM/YYYY"
                                      )}{" "}
                                      <span>[{playlist.eventMediasCount}]</span>
                                    </div>
                                  </span>
                                </div>
                              )
                            )}
                            {/* <p className="firstplaylistVideoImg black" style={{ position: 'absolute', top: '40%' }}>No videos Available</p> */}
                          </>
                          {isFetchingNextPlaylist &&
                          eventListId.eventId == event.id ? (
                            <div className="eventLoader">
                              {" "}
                              <CircularProgress />{" "}
                            </div>
                          ) : (
                            <button
                              disabled={
                                event.playlistsCount === event.playlists.length
                              }
                              className="videoLibraryCardBtn"
                              onClick={() => eventPaginationHandler(event, ind)}
                            >
                              <ArrowForwardIcon />
                            </button>
                          )}
                        </div>
                        {event.id === eventListId && (
                          <>
                            {isFetchingVideo ? (
                              <div className="circularProgress">
                                <CircularProgress />
                              </div>
                            ) : (
                              playListVideos.content &&
                              playListVideos.content.length > 0 && (
                                <div className="videoContainer">
                                  {
                                    <button
                                      disabled={
                                        videoPaginationCount === 0 &&
                                        videoPaginationCount <
                                          playListVideos.totalElements
                                      }
                                      onClick={() =>
                                        VidePaginationHandler("prev")
                                      }
                                    >
                                      <ArrowBackIcon />
                                    </button>
                                  }
                                  {!playListVideos.content &&
                                    playListVideos.message}
                                  <div className="playListVideo">
                                    {playListVideos.content?.map((video) => (
                                      <div
                                        className="mx-1"
                                        key={video.id}
                                        onClick={() =>
                                          displayVideo(video.videoPath)
                                        }
                                      >
                                        <video
                                          src={video.videoPath}
                                          alt="pic"
                                        />
                                      </div>
                                    ))}
                                  </div>
                                  {
                                    <button
                                      disabled={
                                        playListVideos.totalElements > !10 &&
                                        playListVideos.numberOfElements !== 10
                                      }
                                      onClick={() =>
                                        VidePaginationHandler("next")
                                      }
                                    >
                                      <ArrowForwardIcon />
                                    </button>
                                  }
                                </div>
                              )
                            )}
                          </>
                        )}
                        <hr />
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
        {openVideo && (
          <Modal show={true}>
            <Modal.Header>
              <div className="d-flex justify-content-between w-100">
                <h6 className="fs-20 semi-bold black">Video</h6>
                <BsXLg
                  onClick={closeVideoPopup}
                  className="crossview cp"
                ></BsXLg>
              </div>
            </Modal.Header>
            <Modal.Body>
              <ReactPlayer
                id="videoPlayer"
                url={videoPath}
                playing
                controls
                className=""
              />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default VideoLibrary;
